import * as React from 'react';
import FilterFlight from '../FilterFlight/FilterFlight';

const GET_AIRPORTS_V1 = 'catalog/api/v1/airport?';

export default class FilterFlightContainer extends React.Component {

	constructor(props) {
		super(props);
		this.setFilteredList = this.setFilteredList.bind(this);
	}

	setFilteredList(filteredList) {
		this.props.callbackFilteredList(filteredList)
	}

	handleAirportSearch(searchTerm, airport) {
		const reqfilter = {
			searchAirport: searchTerm
		};

		if (airport) {
			reqfilter.ignoreCode = airport.searchCode === '1N' ? '1N' : '';
			reqfilter.ignoreAirport = airport.code;
		}

		const query = Object.keys(reqfilter)
			.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(reqfilter[key]))
			.join('&');

		return fetch(GET_AIRPORTS_V1 + query)
			.then(response => {
				if (response.ok) {
					return response.json();
				} else {
					throw Error();
				}
			})
			.catch((error) => {
				return [];
			});
	}

	render() {
		return (
			<div>
				<FilterFlight
					handleAirportSearch={this.handleAirportSearch}
					searchResult={this.props.searchResult}
					callbackFilteredList={this.setFilteredList}
				/>
			</div>
		);
	}
}





// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/FilterFlightContainer/FilterFlightContainer.jsx